import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    contentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'space-between',
      paddingTop: '0',

    },
    inputError: {
      color: 'red',
    },
    inputDescription: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#8C8C8C',
      marginTop: '8px',
    },
    terms: {
      marginTop: '0px',
      color: colors.fg.subtle,
      ...getTypographyStyles('content_sm_regular'),
    },
    checkLabel: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
      marginTop: '16px',
      '& input': {
        marginTop: '2px',
      },
    },
    resend: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#263ea0',
      backgroundColor: '#00000000',
      marginTop: '8px',
      padding: '0px',
      border: 'none',
    },
    inputLeft: {
      fontWeight: 500,
      fontSize: '16px',
    },
    changeNumberLink: {
      marginTop: 'auto',
      marginBottom: '20px',
      color: '#1DBBF0',
    },
    fileUploadButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '6px 16px',
      gap: '10px',
      background: colors.bg.subtle,
      borderRadius: '8px',
      ...getTypographyStyles('heading_2xs_semibold'),
      color: colors.fg.subtle,
      border: `1px solid ${colors.disabled.muted}`,
      ':hover': {
        cursor: 'pointer',
      },
    },
    fileUploadButtonPrimary: {
      background: colors.primary.default,
      color: colors.base.white,
      border: `1px solid ${colors.disabled.muted}`,
      opacity: 0.9,
      transition: 'opacity 0.3s',
      ':hover': {
        cursor: 'pointer',
        opacity: 1,
      },
    },

    btnWrapper: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      gap: '8px',
    },
    footer: {
      flexDirection: 'column',
      // justifyContent: 'flex-end'
    },
    fileInput: {
      display: 'none',
    },
    checkBox: {
      accentColor: colors.primary.default,
      borderRadius: '4px',
    },
  };
});

export default useStyles;
